// Parse JWT token to get payload
export function parseJwt(token: string) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}

// Get user email from JWT token
export function getUserEmail(): string | null {
  const token = getAuthToken();
  if (!token) return null;
  
  const payload = parseJwt(token);
  return payload?.email || null;
}

// Simple function to get auth token
// Returns dummy token in local development if JWT_LOCAL_EMAIL_ADDRESS is set
export function getAuthToken() {
  const localEmail = import.meta.env.VITE_JWT_LOCAL_EMAIL_ADDRESS;
  
  if (localEmail) {
    return createLocalJWT(localEmail);
  }
  
  return localStorage.getItem('google_token');
};


// Creates a valid JWT token for local development
function createLocalJWT(email: string) {
  // Extract name from email (everything before @)
  const name = email.split('@')[0]
    .split('.')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
  
  const payload = {
    iss: 'https://accounts.google.com',
    email: email,
    email_verified: true,
    name: `${name} (Local)`,
    picture: '',
    sub: `local-dev-${email}`,
    aud: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    iat: Math.floor(Date.now() / 1000),
    exp: Math.floor(Date.now() / 1000) + (365 * 24 * 60 * 60) // 1 year from now
  };
  
  // JWT header
  const header = {
    alg: 'HS256',
    typ: 'JWT'
  };
  
  // Base64 URL encode header and payload (JWT uses URL-safe base64)
  const base64UrlEncode = (str: string) => {
    return btoa(str)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  };
  
  const encodedHeader = base64UrlEncode(JSON.stringify(header));
  const encodedPayload = base64UrlEncode(JSON.stringify(payload));
  
  // Create a dummy signature (not cryptographically valid but structurally correct)
  const signature = 'dummy-signature-for-local-dev';
  
  return `${encodedHeader}.${encodedPayload}.${signature}`;
};